import Styled from 'styled-components'

export const Content = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem 0;
  
  .bg-gray {
    background-color: #FAFBFF;
  }
`
export const Footer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;

  button {
    width: 100% !important;
    max-width: 400px;
    height: 48px;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
  }
`

export const Img = Styled.img`
  width: 139.07px;
  height: 104.28px;
  margin-bottom: 10px;
`

export const IconContainer = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border: 3px solid #000;
  border-radius: 50%;
  margin-bottom: 2rem;
  svg {
    font-size: 32px;
    color: #000;
  }
`

export const OrderNumber = Styled.span`
  position: relative;
  left: 30%
`

export const SubLabel = Styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #00003C99;
  opacity: 0.6;
  margin-bottom: 32px;
`

export const Label = Styled.p`
  font-weight: 400;
  font-size: 24px;
  line-height: 40px;
  text-align: center;
  color: #1A2138;
  margin-bottom: 8px;
`

export const OrderBox = Styled.div`
  background-color: #F4F7FF;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  margin-top: 2rem;
  
  p {
    color: #8E97B1;
    font-size: 16px;
    line-height: 150%;
    margin-bottom: 0.5rem;
  }
  
  h3 {
    color: #000033;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    margin: 0;
    word-break: break-all;
  }
`